import { OptionKV } from "~styled/selector/Selector";

export const TODOS = "PolizaEmitida,Rechazada";
export const POLIZAEMITIDA = "PolizaEmitida";
export const RECHAZADA = "Rechazada";

const estadosSolicitudEmisionOptions: Record<string, string> = {
  [TODOS]: "Todos",
  [POLIZAEMITIDA]: "Póliza Emitida",
  [RECHAZADA]: "Rechazada",
};

const estadosSolicitudEmision: string[] = [POLIZAEMITIDA, RECHAZADA];

const estadosSolicitudEmisionFilter: OptionKV<string>[] = [
  { label: estadosSolicitudEmisionOptions[TODOS], value: TODOS },
  {
    label: estadosSolicitudEmisionOptions[POLIZAEMITIDA],
    value: POLIZAEMITIDA,
  },
  {
    label: estadosSolicitudEmisionOptions[RECHAZADA],
    value: RECHAZADA,
  },
];

export {
  estadosSolicitudEmisionOptions,
  estadosSolicitudEmision,
  estadosSolicitudEmisionFilter,
};
